import { Container } from "@chakra-ui/react";
import React from "react";

const WhyUS = () => {
  return <Container>
    Why Join us
  </Container>
};

export default WhyUS;
